import Currency from '@cbgms/components/general/Currency'

interface Props {
  content: number
}

export function Money({ content }: Props) {
  return content !== null ? <Currency amount={content} /> : null
}
